import { Label } from "@xola/ui-kit";
import { SwitchField } from "common";
import { useFormikContext } from "formik";
import React from "react";
import { CheckoutPreference } from "types";

interface FormValues {
    checkout: CheckoutPreference;
}

export const BotDefenseSection = () => {
    const { values, setFieldValue } = useFormikContext<FormValues>();

    const isEnabled = values.checkout.captchaEnabled ?? false;

    return (
        <div data-testid="fraud-fighter-bot-defense-section">
            <Label>Enable Bot Defense</Label>
            <SwitchField
                isChecked={isEnabled}
                onChange={(isChecked: boolean) => setFieldValue("checkout.captchaEnabled", isChecked)}
            >
                Enable frictionless bot defense
            </SwitchField>
        </div>
    );
};
